<template>
  <div class="processing-history">
    <div v-if="historyList && historyList.length > 0" class="history-timeline">
      <div
        v-for="(item, index) in historyList"
        :key="index"
        class="history-timeline-item"
      >
        <div class="history-card">
          <div class="history-card-top">
            <div>
              <div class="history-date">{{ formatDate(item.date) }}</div>
            </div>
            <span class="history-status-badge" :class="getStatusClass(item.status)">
              {{ item.status || "Cập nhật" }}
            </span>
          </div>

          <div class="history-description">
            <span v-if="item.user_name">
              <span style="font-weight: bold;">{{ item.user_name }}</span> đã chuyển trạng thái xử lý thành <span style="font-weight: bold;">{{ item.status }}</span>
            </span>
          </div>

          <div v-if="item.description" class="history-note">
            {{ stripHtml(item.description) }}
          </div>
        </div>
      </div>
    </div>

    <div v-else class="history-empty-state">
      <div class="history-empty-text">
        Chưa có lịch sử xử lý
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";

export default {
  name: "ProcessingHistory",
  props: {
    historyList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    getStatusClass(status) {
      const statusClasses = {
        "Chưa tiếp nhận": "bg-gray",
        "Đang xử lý": "bg-yellow",
        "Đã cung cấp đủ hàng": "bg-blue",
        "Đã nhận hàng": "bg-teal",
        "Hoàn thành": "bg-green",
        Hủy: "bg-danger-soft",
      };
      return statusClasses[status] || "bg-gray";
    },
    stripHtml(value) {
      if (!value) return "";
      const temp = document.createElement("div");
      temp.innerHTML = value;
      return (temp.textContent || temp.innerText || "").trim();
    },
  },
};
</script>

<style scoped>
.processing-history {
  max-height: 620px;
  overflow-y: auto;
}

.history-timeline {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.history-timeline-item {
  display: block;
}

.history-card {
  padding: 16px 18px;
  border: 1px solid #e8edf4;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.03);
}

.history-card-top {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 10px;
}

.history-date {
  margin-top: 4px;
  color: #94a3b8;
  font-size: 13px;
  font-weight: 600;
}

.history-description {
  color: #334155;
  font-size: 14px;
  line-height: 1.7;
}

.history-note {
  margin-top: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #f8fafc;
  color: #475569;
  font-size: 13px;
  line-height: 1.7;
  border: 1px solid #eef2f7;
}

.history-status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  border: 1px solid transparent;
}

.history-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 240px;
  padding: 32px 24px;
  border: 1px dashed #d9e2ec;
  border-radius: 18px;
  background: linear-gradient(180deg, #fbfcfe 0%, #f8fafc 100%);
  text-align: center;
}

.history-empty-text {
  max-width: 340px;
  margin-top: 8px;
  color: #64748b;
  font-size: 14px;
  line-height: 1.7;
}

.bg-yellow {
  background: #fff3cd;
  color: #8a5a00;
  border-color: #ffe08a;
}

.bg-gray {
  background: #eef1f5;
  color: #5f6b7a;
  border-color: #d7dee7;
}

.bg-teal {
  background: #e6fffb;
  color: #0f8b82;
  border-color: #9be7df;
}

.bg-danger-soft {
  background: #fdecec;
  color: #d14343;
  border-color: #f6bcbc;
}

.history-status-badge.bg-blue {
  background: #e8f1ff;
  color: #0b63f6;
  border-color: #b8d2ff;
}

.history-status-badge.bg-green {
  background: #e9f9ee;
  color: #14833b;
  border-color: #b7e4c7;
}

@media screen and (max-width: 767px) {
  .history-card-top {
    flex-direction: column;
  }
}
</style>
